import React, { Fragment } from 'react';
import { config } from 'helpers';
import { Hero } from '.';
import { Outro } from '../common';
import { Icons, Video, Button, Document } from 'components';
import css from './overview.scss';

export function Overview(props) {
  return (
    <Fragment>
      <Document.Title>Overview</Document.Title>
      <Document.Description>Discover Your Personal Success Formula. Life coaching is about closing the gap between where you are today and where you want to be.</Document.Description>
      <Hero {...props} />
      <div className={css.intro}>
        <div className={css.container}>
          { config.sw && <Video src="https://evphosted-14ed4125c423d5.s3.amazonaws.com/video-overview2-overview2960x720-overview2960x720-1.mp4" aspectRatio={3/4} /> }
          <p className={css.lead}>Success is the ability to realize your dreams and achieve your goals in each of the important areas of your life. Success is about living a happy, meaningful and fulfilling life.</p>
        </div>
      </div>
      <div className={css.program}>
        <div className={css.container}>
          <h2>The Program</h2>
          <p>Success Wizard provides you with a structured step-by-step process and a powerful set of tools that will educate, support, and guide you through a personal life-changing journey of self-discovery and self-realization.</p>
          <p>The core program consists of three modules that were specifically designed to take you through the three key elements in the process of discovering and creating your best life: Clarity, Goals and Action.</p>
          { config.sw && <Video src="https://evphosted-14ed4125c423d5.s3.amazonaws.com/master-motion-success-wizard-program-desc-v5-1-1.mp4" /> }
        </div>
        <ul className={css.grid}>
          <li>
            <Icons.Glasses />
            <h4>Self-Discovery</h4>
            <p>Self-Discovery is at the heart of change and our Clarity Wizard guides you through a process of learning, reflection and self-awareness. Sets of questionnaires and exercises support you in discovering who you are, what you really want (and why), and who you would like to be.</p>
          </li>
          <li>
            <Icons.Goal />
            <h4>Goal Setting</h4>
            <p>Goals give form and direction to our lives, and { config.appName } is about translating your life into a concrete set of goals, and then developing a detailed roadmap and action plan to achieve your dreams and desires.</p>
          </li>
          <li>
            <Icons.Action />
            <h4>Focused Action</h4>
            <p>Dreams and goals are only that without action. The Action Wizard is designed to guide you through each day to ensure that your focus, attention and actions are effectively getting closer to achieving your goals in every part of your life.</p>
          </li>
        </ul>
      </div>
      <div className={css.quiz}>
        <div className={css.cont2ainer}>
          <h2>Are You Ready For Your Midlife Transition?</h2>
          <p>Most people never really consider what they want in their lives and only a few are actually doing something about it.</p>
          <p>If you believe there is more to life than what you are currently experiencing, if you are motivated to explore and experience all that life has to offer, then Success Wizard has been created for you.</p>
          <p>Go over the list and check the statements that are true for you:</p>
          <ul className={css.checklist}>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready for life filled with meaning, success and significance
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready to make real and lasting changes in my life
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready to set goals and take action to achieve my dreams
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready to stay focused and on track and get results
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready for midlife transition and meaningful life after 40
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready for life filled with meaning, success and significance
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready to make real and lasting changes in my life
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready to set goals and take action to achieve my dreams
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready to stay focused and on track and get results
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" />
                <span className={css.checkbox}><Icons.Check /></span>
                I am ready for midlife transition and meaningful life after 40
              </label>
            </li>
          </ul>
          <h3>Ready?</h3>
          <p>This is your opportunity to grow, develop yourself and utilize all your potential. Are you ready to commit yourself to creating the best life you can for yourself? Are you willing to commit to focusing on the things that matter the most to you?</p>
          <p>This is a long-term commitment. You can expect to see results almost immediately, but in order to fully transform your life you will need to engage with these practices on a regular basis.</p>
          <p className={css.footer}>
            <Button to="/sign-up/?redirect=/settings/membership/" white>Start { config.trialPeriod }</Button>
          </p>
        </div>
      </div>
      <Outro>
        <p className={css.lead}>So now the decision is yours. You can wait and do nothing (like most people) or you can start moving, take charge over your own destiny and start living life to the fullest!</p>
        <ul className={css.list}>
          <li><Icons.Check /> You can experience more abundance in your life</li>
          <li><Icons.Check /> You can live more meaningful and authentic life</li>
          <li><Icons.Check /> You can achieve your most important goals</li>
        </ul>
      </Outro>
    </Fragment>
  );
}
